import { render, staticRenderFns } from "./CategoriesDetail.vue?vue&type=template&id=cbe643f2&lang=html&"
import script from "./CategoriesDetail.vue?vue&type=script&lang=js&"
export * from "./CategoriesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports